import { prop, map, valueOr, compose, join } from 'utils/fp'

export const parseMessages = compose(
  join(', '),
  map(prop('message')),
  valueOr([])
)



// WEBPACK FOOTER //
// ./src/utils/graphql.js